import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

export const FeatureDetails = () => {
  const { t } = useLanguage();

  return (
    <section className="feature-details-section" id="features-mid">
      <div className="section-header">
        <h2 className="section-title">{t('details.sectionTitle')}</h2>
        <span className="section-line" />
      </div>

      <div className="details-container">
        <div className="details-row">
          <motion.div 
            className="details-img-col"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <img src="/images/tg_dashboard.png" alt="Telegram Marketing Core" className="details-img" />
          </motion.div>
          
          <motion.div 
            className="details-text-col"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <h2>{t('details.block1.title')}</h2>
            <p className="p-highlight">{t('details.block1.p1')}</p>
            <p>{t('details.block1.p2')}</p>
            <p>{t('details.block1.p3')}</p>
          </motion.div>
        </div>

        <div className="details-row reverse">
          <motion.div 
            className="details-img-col"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <img src="/images/tg_parsing.png" alt="Mass Mailing Setup" className="details-img" />
          </motion.div>
          
          <motion.div 
            className="details-text-col"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <h2>{t('details.block2.title')}</h2>
            <p className="p-highlight">{t('details.block2.p1')}</p>
            <p>{t('details.block2.p2')}</p>
          </motion.div>
        </div>

        <div className="details-row">
          <motion.div 
            className="details-img-col"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <img src="/images/tg_warmup.png" alt="AI Account Warmup Module" className="details-img" />
          </motion.div>
          
          <motion.div 
            className="details-text-col"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <h2>{t('details.block3.title')}</h2>
            <p className="p-highlight">{t('details.block3.p1')}</p>
            <p>{t('details.block3.p2')}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FeatureDetails;